import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { PartnerCenterSeller } from "../../server/partnerCenter/models/entities";
import { MiddlewarePartner } from "../../server/partnerCenter/models/middlewarePartner";
import { PartnerCenterActions, partnerCenterActions } from "../actions/partnerCenterActions";
import { PartnerCenterScope } from "../scopes";

export type CountryValidationData = {
  isCityRequired: boolean;
  isPostalCodeRequired: boolean;
  isStateRequired: boolean;
  postalCodeRegex?: string;
  states?: string[];
};

const initialState: PartnerCenterState = {};

export type PartnerCenterState = {
  countryValidations?: Record<string, CountryValidationData>;
  sellers?: PartnerCenterSeller[];
  middlewarePartners?: MiddlewarePartner[];
};

export const updateCountryValidations = (
  state: PartnerCenterState,
  action: ReturnType<typeof partnerCenterActions.fetchCountryValidation.success>
): PartnerCenterState => ({
  ...state,
  countryValidations: {
    ...state.countryValidations,
    [action.country]: {
      ...action.data,
      isCityRequired: action.data.isCityRequired === true,
    },
  },
});

export const updateSellers = (
  state: PartnerCenterState,
  action: ReturnType<typeof partnerCenterActions.updateSellers>
): PartnerCenterState => ({
  ...state,
  sellers: action.sellers ?? [],
});

export const updateMiddlewarePartners = (
  state: PartnerCenterState,
  action: ReturnType<typeof partnerCenterActions.updateMiddlewarePartners>
): PartnerCenterState => ({
  ...state,
  middlewarePartners: action.middlewarePartners ?? [],
});

export const partnerCenterReducer = withScope(
  [PartnerCenterScope],
  new ReducerChain<PartnerCenterState>(initialState)
    .on(PartnerCenterActions.FETCH_COUNTRY_VALIDATION_COMPLETED, updateCountryValidations)
    .on(PartnerCenterActions.UPDATE_SELLERS, updateSellers)
    .on(PartnerCenterActions.UPDATE_MIDDLEWARE_PARTNERS, updateMiddlewarePartners)
    .build()
);
